import { render, staticRenderFns } from "./AnnouncementPage.vue?vue&type=template&id=601a7d3e"
import script from "./AnnouncementPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports